module.exports = __webpack_public_path__ + "4f8becdee9daa9e6e79fe7e5e6e4fbef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-21.png
// module id = 1704
// module chunks = 0